import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {environment} from '../../../../../environments/environment';
import {User} from '../../../_models/User';
import { Filter } from '../_models/filter';
import { SortEvent } from '../../_models/SortEvent';
import { map, catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    protected api_url = environment.api_url;

    /**
     * Constructor
     *
     * @param {HttpClient} httpClient
     */
    constructor(protected httpClient: HttpClient) {

    }

    /**
     * Permettant de retourner les informations details de lutilisateur courant
     * @param page numéro de page
     * @param size nombre des élements
     * @param filter filtre
     */
    GetListUser(page: number, size: number, filter: Filter, role: boolean, sortEvent?: SortEvent): Observable<any> {

        let queryParameters = new HttpParams();
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (filter?.ville !== undefined && filter?.ville != null && filter?.ville.length > 0) {
            filter.ville.forEach((ville: string) => {
                queryParameters = queryParameters.append(`goverments[]`, ville);
            });
        }

        if (filter?.cardNumber !== undefined && filter?.cardNumber !== null) {
            queryParameters = queryParameters.set('cardNumber', <any> filter.cardNumber);
        }

        if (filter?.firstName !== undefined && filter?.firstName !== null) {
            queryParameters = queryParameters.set('firstName', <any> filter.firstName);
        }
        if (filter?.lastName !== undefined && filter?.lastName !== null) {
            queryParameters = queryParameters.set('lastName', <any> filter.lastName);
        }
        if (filter?.cin !== undefined && filter?.cin !== null) {
            queryParameters = queryParameters.set('cin', <any> filter.cin);
        }
        if (filter?.email !== undefined && filter?.email !== null) {
            queryParameters = queryParameters.set('email', <any> filter.email);
        }
        if (filter?.status !== undefined && filter?.status !== null  && filter?.status.trim() !== '') {
            queryParameters = queryParameters.set('actif', <any> filter.status);
        }
        if (filter?.phone !== undefined && filter?.phone !== null) {
            queryParameters = queryParameters.set('phone', <any> filter.phone);
        }
        if (filter?.date_inscription_start !== undefined && filter?.date_inscription_start !== null) {
            queryParameters = queryParameters.set('date_inscription_start', <any> filter.date_inscription_start);
        }
        if (filter?.date_inscription_end !== undefined && filter?.date_inscription_end !== null) {
            queryParameters = queryParameters.set('date_inscription_end', <any> filter.date_inscription_end);
        }
        if (filter?.contribution !== undefined && filter?.contribution !== null && filter?.contribution.trim() !== '') {
            queryParameters = queryParameters.set('contribution', <any> filter.contribution);
        }
        if (filter?.gender !== undefined && filter?.gender !== null) {
            queryParameters = queryParameters.set('gender', <any> filter.gender);
        }
        if (filter?.folderNumber !== undefined && filter?.folderNumber !== null) {
            queryParameters = queryParameters.set('folderNumber', <any> filter.folderNumber);
        }
        if (filter?.folderStatus !== undefined && filter?.folderStatus !== null) {
            queryParameters = queryParameters.set('folderStatus', <any> filter.folderStatus);
        }
        if (filter?.quality !== undefined && filter?.quality !== null) {
            queryParameters = queryParameters.set('quality', <any> filter.quality);
        }
        if(sortEvent?.active)
            queryParameters = queryParameters.set('sortKey', <any> sortEvent.active);
        if(sortEvent?.direction)
            queryParameters = queryParameters.set('direction', <any> sortEvent.direction);

        let headers = new HttpHeaders();
        headers = headers.set('Hidden-Param', btoa(role ? 'ROLE_TRAINEE' : 'ROLE_USER'))

        return this.httpClient.request<any>('get', `${this.api_url}/api/user/active`,
            {
                params: queryParameters,
                headers: headers,
            }
        );
    }

    /**
     * Recherche les utilisateurs actifs avec filtre OR
     * Utilise l'API /active/search qui recherche le terme dans plusieurs champs avec OR
     * @param searchTerm Terme de recherche qui sera cherché dans nom, prénom, CIN, carte, dossier
     * @param page Numéro de page
     * @param size Nombre d'éléments par page
     */
    SearchActiveUsersWithOr(searchTerm: string, page: number, size: number): Observable<any> {
        let queryParameters = new HttpParams();
        
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        
        // Envoyer le terme de recherche dans tous les champs pertinents
        // Le backend fera une recherche avec OR entre ces champs
        if (searchTerm !== undefined && searchTerm !== null && searchTerm.trim() !== '') {
            const term = searchTerm.trim();
            queryParameters = queryParameters.set('firstName', term);
            queryParameters = queryParameters.set('lastName', term);
            queryParameters = queryParameters.set('cin', term);
            queryParameters = queryParameters.set('cardNumber', term);
            queryParameters = queryParameters.set('folderNumber', term);
            queryParameters = queryParameters.set('email', term);
        }
        
        const headers = new HttpHeaders();
        
        return this.httpClient.request<any>('get', `${this.api_url}/api/user/active/search`,
            {
                params: queryParameters,
                headers: headers,
            }
        );
    }

    /**
     * Permettant de retourner les informations details de lutilisateur courant
     */
    GetUserdetails(): Observable<any> {
        const queryParameters = new HttpParams();
        const headers = new HttpHeaders();

        return this.httpClient.request<any>('get', `${this.api_url}/api/user/details`,
            {
                headers: headers,
            }
        );
    }

    /**
     * Permettant de retourner les informations details de lutilisateur courant
     *
     * @param userId
     *
     */
    GetUserById(userId: string): Observable<any> {
        const queryParameters = new HttpParams();
        const headers = new HttpHeaders();

        return this.httpClient.request<any>('get', `${this.api_url}/api/user/admin/details/${userId}`,
            {
                headers: headers,
            }
        );
    }

    /**
     * Permettant de modifier les informations  details utilisateur
     *
     * @param userId
     * @param user information utilisateur
     * @param passowrd information utilisateur
     *
     */
    UpdateUser(userId: string, user: User, passowrd: string): Observable<any> {
        let headers = new HttpHeaders();
        if(passowrd)
        headers = headers.append('password', passowrd);
        return this.httpClient.request<any>('put', `${this.api_url}/api/user/admin/update/${userId}`,
            {
                headers: headers,
                body: user
            }
        );
    }

    /**
     * Permettant de modifier les informations details utilisateur
     *
     * @param user information utilisateur
     *
     */
    createUser(user: User, imageFile?: File): Observable<any> {
        const formData = new FormData();
        
        // Préparer l'objet user pour l'envoi
        const userToSend = {
            ...user,
            userArabInfo: user.userArabInfo || {},
            qualityInfo: user.qualityInfo || {}
        };

        // Créer un Blob avec le type application/json
        const userBlob = new Blob([JSON.stringify(userToSend)], {
            type: 'application/json'
        });

        // Ajouter l'utilisateur comme partie nommée 'user'
        formData.append('user', userBlob, 'user.json');

        // Ajouter l'image si elle existe
        if (imageFile) {
            formData.append('imagefile', imageFile, imageFile.name);
        }

        // Récupérer le token d'authentification
        const token = localStorage.getItem('accessToken');

        return this.httpClient.post<any>(
            `${this.api_url}/api/user/add`,
            formData,
            {
                headers: new HttpHeaders({
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                })
            }
        );
    }

    /**
     * Permet de retourner la liste des utilisateurs membres a une entreprise
     * @param companyPublicId
     */
     GetListCompanyMembers(companyPublicId: string): Observable<any> {
        const queryParameters = new HttpParams();
        const headers = new HttpHeaders();

        return this.httpClient.request<any>('get', `${this.api_url}/api/user/companyMember/${companyPublicId}`,
            {
                headers: headers,
            }
        );
    }

    /**
     * Permettant de retourner les informations details de lutilisateur courant
     */
     ImportDataBaseFile(formaData): Observable<any> {
        const headers = new HttpHeaders({
            'Accept': 'application/json'
        });
        return this.httpClient.request<any>('POST', `${this.api_url}/api/user/readFromCSV`,
            {
                headers: headers,
                body: formaData,
                observe: 'response'
            }).pipe(
                map(response => response.body),
                catchError(error => {
                    console.error('Erreur ImportDataBaseFile:', error);
                    // Si l'erreur est 403 et contient un message, on le retourne
                    if (error.status === 403) {
                        if (error.error && error.error.message) {
                            return throwError({ 
                                status: error.status, 
                                message: error.error.message,
                                isCustomError: true
                            });
                        } else if (Array.isArray(error.error)) {
                            // Si l'erreur est un tableau de messages
                            return throwError({ 
                                status: error.status, 
                                messages: error.error,
                                isCustomError: true
                            });
                        }
                    }
                    return throwError(error);
                })
            );
        }


        validateDataBaseFile(formaData): Observable<any> {
            const headers = new HttpHeaders({
                'Accept': 'application/json'
            });
            return this.httpClient.request<any>('POST', `${this.api_url}/api/user/readFromCSV`,
                {
                    headers: headers,
                    body: formaData,
                    observe: 'response'
                }).pipe(
                    map(response => response.body),
                    catchError(error => {
                        console.error('Erreur validateDataBaseFile:', error);
                        // Si l'erreur est 403 et contient un message, on le retourne
                        if (error.status === 403) {
                            if (error.error && error.error.message) {
                                return throwError({ 
                                    status: error.status, 
                                    message: error.error.message,
                                    isCustomError: true
                                });
                            } else if (Array.isArray(error.error)) {
                                // Si l'erreur est un tableau de messages
                                return throwError({ 
                                    status: error.status, 
                                    messages: error.error,
                                    isCustomError: true
                                });
                            }
                        }
                        return throwError(error);
                    })
                );
            }
    /**
     * Permet de changer le rôle d'un utilisateur
     * @param userId
     * @param role
     */
     SetRoleMember(userId: string, role: string): Observable<any> {
        let queryParameters = new HttpParams();

        queryParameters = queryParameters.set('role',role)

        const headers = new HttpHeaders();

        return this.httpClient.request<any>('put', `${this.api_url}/api/super/user/setRole/${userId}`,
            {
                headers: headers,
                params: queryParameters
            }
        )
     }

     /**
      * Permet d'ajouter un rôle spécifique à un utilisateur sans modifier les autres rôles
      * @param userId ID de l'utilisateur
      * @param roleId ID du rôle à ajouter (ex: "2" pour ROLE_ADMIN)
      */
     addRoleToUser(userId: string, roleId: string): Observable<any> {
        const headers = new HttpHeaders();
        
        return this.httpClient.request<any>('post', `${this.api_url}/api/user/role/${userId}/${roleId}`,
            {
                headers: headers
            }
        );
     }

    /**
     * Permet d'activer ou désactiver un utilisteurs
     * @param publicId
     */
     ChangeUserStatus(publicId: string, status:boolean): Observable<any> {
        let queryParameters = new HttpParams();
        if (status !== undefined && status!== null) {
            queryParameters = queryParameters.set('status', <any> status);
        }

        if (publicId === undefined || publicId === null) {
            console.error("Public ID is required"); 
         }
        const headers = new HttpHeaders();

        return this.httpClient.request<any>('post', `${this.api_url}/api/user/changeStatus/${publicId}`,
            {
                headers: headers,
                params: queryParameters
            }
        );
    }
    
    /* Permet d'exporter list des utilisateurs en .excel
     * @param filter
     */
    ExportCSV(filter: Filter, size:number): Observable<any> {
        let queryParameters = new HttpParams();

        queryParameters = queryParameters.set('size', <any> size);

        if (filter?.ville !== undefined && filter?.ville != null && filter?.ville.length > 0) {
            filter.ville.forEach((ville: string) => {
                queryParameters = queryParameters.append(`goverments[]`, ville);
            });
        }

        if (filter?.cardNumber !== undefined && filter?.cardNumber !== null) {
            queryParameters = queryParameters.set('cardNumber', <any> filter.cardNumber);
        }

        if (filter?.firstName !== undefined && filter?.firstName !== null) {
            queryParameters = queryParameters.set('firstName', <any> filter.firstName);
        }
        if (filter?.lastName !== undefined && filter?.lastName !== null) {
            queryParameters = queryParameters.set('lastName', <any> filter.lastName);
        }
        if (filter?.cin !== undefined && filter?.cin !== null) {
            queryParameters = queryParameters.set('cin', <any> filter.cin);
        }
        if (filter?.email !== undefined && filter?.email !== null) {
            queryParameters = queryParameters.set('email', <any> filter.email);
        }
        if (filter?.status !== undefined && filter?.status !== null  && filter?.status.trim() !== '') {
            queryParameters = queryParameters.set('actif', <any> filter.status);
        }
        if (filter?.phone !== undefined && filter?.phone !== null) {
            queryParameters = queryParameters.set('phone', <any> filter.phone);
        }
        if (filter?.date_inscription_start !== undefined && filter?.date_inscription_start !== null) {
            queryParameters = queryParameters.set('date_inscription_start', <any> filter.date_inscription_start);
        }
        if (filter?.date_inscription_end !== undefined && filter?.date_inscription_end !== null) {
            queryParameters = queryParameters.set('date_inscription_end', <any> filter.date_inscription_end);
        }
        if (filter?.contribution !== undefined && filter?.contribution !== null && filter?.contribution.trim() !== '') {
            queryParameters = queryParameters.set('contribution', <any> filter.contribution);
        }
        if (filter?.gender !== undefined && filter?.gender !== null) {
            queryParameters = queryParameters.set('gender', <any> filter.gender);
        }
        const headers = new HttpHeaders();
        return this.httpClient.request<any>('get', `${this.api_url}/api/user/export`,
            {
                params: queryParameters,
                headers: headers,
            }
        );
    }

    /**
     * Récupère la liste des administrateurs (réponse paginée)
     */
    getAdmins(
        page: number = 0,
        size: number = 10,
        filter?: { email?: string; firstName?: string; lastName?: string; cardNumber?: string; folderNumber?: string }
    ): Observable<PageResponse<User>> {
        const headers = new HttpHeaders();
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('size', size.toString());
        const setIf = (key: string, val?: string) => {
            const v = (val || '').toString().trim();
            if (v.length > 0) { params = params.set(key, v); }
        };
        if (filter) {
            setIf('email', filter.email);
            setIf('firstName', filter.firstName);
            setIf('lastName', filter.lastName);
            setIf('cardNumber', filter.cardNumber);
            setIf('folderNumber', filter.folderNumber);
        }
        return this.httpClient.request<PageResponse<User>>(
            'get',
            `${this.api_url}/api/user/role/admin`,
            { headers, params }
        );
    }

    convertDate(list:User[]): Observable<any> {
        let queryParameters = new HttpParams();

        const headers = new HttpHeaders();

        return this.httpClient.request<any>('put', `${this.api_url}/api/user/format`,
            {
                headers: headers,
                body: list
            }
        );
    }

    /**
     * Permettant de ajouter une cotisation pour un utilisateur
     *
     * @param publicId id utilisateur
     *
     */
     addCotisationForUser(publicId: string): Observable<any> {
        const queryParameters = new HttpParams();
        const headers = new HttpHeaders();

        return this.httpClient.request<any>('post', `${this.api_url}/api/user/add/cotisation/afterInsert/${publicId}`,
            {
                headers: headers,
            }
        );
    }

    /**
     * Permettant de retourner les information de l'utilisateur par n° carte pro
     *
     * @param cardNumber id utilisateur
     *
     */
    GetUserByCardNumber(cardNumber: string): Observable<any> {
        let queryParameters = new HttpParams();
        const headers = new HttpHeaders();

        return this.httpClient.request<any>('get', `${this.api_url}/api/user/getUserByCardNumber/${cardNumber}`,
            {
                headers: headers,
            }
        );
    }

    getManagementByIdUSer(userId): Observable<any> {
        const headers = new HttpHeaders();

        return this.httpClient.request<any>('get', `${this.api_url}/api/trainee/management/byIdUser/${userId}`,
            {
                headers: headers,
            }
        );
    }

    /**
     * Permet d'archiver un utilisateur
     * @param userId ID de l'utilisateur à archiver
     */
    archiveUser(userId: string): Observable<any> {
        const headers = new HttpHeaders();
        return this.httpClient.request<any>('put', `${this.api_url}/api/user/archive/${userId}`,
            {
                headers: headers
            }
        );
    }

    /**
     * Permet de désarchiver un utilisateur
     * @param userId ID de l'utilisateur à désarchiver
     */
    unarchiveUser(userId: string): Observable<any> {
        const headers = new HttpHeaders();
        return this.httpClient.request<any>('put', `${this.api_url}/api/user/unarchive/${userId}`,
            {
                headers: headers
            }
        );
    }

    /**
     * Permet de récupérer la liste des utilisateurs archivés
     * @param page numéro de page
     * @param size nombre des élements
     * @param filter filtre
     * @param role boolean pour les permissions
     * @param sortEvent tri
     */
    GetArchivedUsersList(page: number, size: number, filter: Filter, role: boolean, sortEvent?: SortEvent): Observable<any> {
        let queryParameters = new HttpParams();
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (filter?.ville !== undefined && filter?.ville != null && filter?.ville.length > 0) {
            filter.ville.forEach((ville: string) => {
                queryParameters = queryParameters.append(`goverments[]`, ville);
            });
        }

        if (filter?.cardNumber !== undefined && filter?.cardNumber !== null) {
            queryParameters = queryParameters.set('cardNumber', <any> filter.cardNumber);
        }

        if (filter?.firstName !== undefined && filter?.firstName !== null) {
            queryParameters = queryParameters.set('firstName', <any> filter.firstName);
        }
        if (filter?.lastName !== undefined && filter?.lastName !== null) {
            queryParameters = queryParameters.set('lastName', <any> filter.lastName);
        }
        if (filter?.cin !== undefined && filter?.cin !== null) {
            queryParameters = queryParameters.set('cin', <any> filter.cin);
        }
        if (filter?.email !== undefined && filter?.email !== null) {
            queryParameters = queryParameters.set('email', <any> filter.email);
        }
        if (filter?.status !== undefined && filter?.status !== null  && filter?.status.trim() !== '') {
            queryParameters = queryParameters.set('actif', <any> filter.status);
        }
        if (filter?.phone !== undefined && filter?.phone !== null) {
            queryParameters = queryParameters.set('phone', <any> filter.phone);
        }
        if (filter?.date_inscription_start !== undefined && filter?.date_inscription_start !== null) {
            queryParameters = queryParameters.set('date_inscription_start', <any> filter.date_inscription_start);
        }
        if (filter?.date_inscription_end !== undefined && filter?.date_inscription_end !== null) {
            queryParameters = queryParameters.set('date_inscription_end', <any> filter.date_inscription_end);
        }
        if (filter?.contribution !== undefined && filter?.contribution !== null && filter?.contribution.trim() !== '') {
            queryParameters = queryParameters.set('contribution', <any> filter.contribution);
        }
        if (filter?.gender !== undefined && filter?.gender !== null) {
            queryParameters = queryParameters.set('gender', <any> filter.gender);
        }
        if (filter?.folderNumber !== undefined && filter?.folderNumber !== null) {
            queryParameters = queryParameters.set('folderNumber', <any> filter.folderNumber);
        }
        if (filter?.folderStatus !== undefined && filter?.folderStatus !== null) {
            queryParameters = queryParameters.set('folderStatus', <any> filter.folderStatus);
        }
        if (filter?.quality !== undefined && filter?.quality !== null) {
            queryParameters = queryParameters.set('quality', <any> filter.quality);
        }
        if (filter?.archivedAt !== undefined && filter?.archivedAt !== null && String(filter.archivedAt).trim() !== '') {
            queryParameters = queryParameters.set('archivedAt', <any> filter.archivedAt);
        }
        if(sortEvent?.active)
            queryParameters = queryParameters.set('sortKey', <any> sortEvent.active);
        if(sortEvent?.direction)
            queryParameters = queryParameters.set('direction', <any> sortEvent.direction);

        let headers = new HttpHeaders();
        headers = headers.set('Hidden-Param', btoa(role ? 'ROLE_TRAINEE' : 'ROLE_USER'))

        return this.httpClient.request<any>('get', `${this.api_url}/api/user/archived`,
            {
                params: queryParameters,
                headers: headers,
            }
        );
    }

    /**
     * Historique des ordres disciplinaires d'un utilisateur
     */
    getDisciplinaryOrdersHistory(userId: string){
        return this.httpClient.get(`${this.api_url}/api/user/disciplinaryOrder/list/${userId}`)
    }

    /**
     * Récupère l'ordre disciplinaire récent d'un utilisateur
     * @param userId ID de l'utilisateur
     */
    getRecentDisciplinaryOrderByUserId(userId: string): Observable<any> {
        const headers = new HttpHeaders();
        return this.httpClient.request<any>('get', `${this.api_url}/api/user/disciplinaryOrder/byId/${userId}`,
            {
                headers: headers,
            }
        );
    }

    /**
     * Crée un administrateur externe
     */
    createExternalAdmin(payload: any): Observable<any> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.httpClient.post(`${this.api_url}/api/external-admin/create`, payload, { headers });
    }

    /**
     * Retourne uniquement les utilisateurs (exclut autres rôles côté backend)
     */
    getOnlyUsers(page: number, size: number, filter: any = {}, sortEvent?: SortEvent): Observable<any> {
        let queryParameters = new HttpParams();
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', String(page));
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', String(size));
        }
        if (filter?.firstName) {
            queryParameters = queryParameters.set('firstName', filter.firstName as string);
        }
        if (filter?.lastName) {
            queryParameters = queryParameters.set('lastName', filter.lastName as string);
        }
        if (filter?.email) {
            queryParameters = queryParameters.set('email', filter.email as string);
        }
        if (filter?.cardNumber) {
            queryParameters = queryParameters.set('cardNumber', filter.cardNumber as string);
        }
        if (filter?.folderNumber) {
            queryParameters = queryParameters.set('folderNumber', filter.folderNumber as string);
        }
        if (filter?.status) {
            queryParameters = queryParameters.set('actif', filter.status as string);
        }
        if (sortEvent?.active) {
            queryParameters = queryParameters.set('sortKey', sortEvent.active as string);
        }
        if (sortEvent?.direction) {
            queryParameters = queryParameters.set('direction', sortEvent.direction as string);
        }
        const headers = new HttpHeaders();
        return this.httpClient.request<any>('get', `${this.api_url}/api/user/only-user`, {
            params: queryParameters,
            headers
        });
    }
}


export interface PageResponse<T> {
    content: T[];
    totalElements: number;
    pageable?: any;
    totalPages?: number;
    last?: boolean;
    number?: number;
    size?: number;
    first?: boolean;
    numberOfElements?: number;
    empty?: boolean;
}
